export default {

    data() {
        return {

        }
    },
    methods: {

        getProgressBarValue(index) {

            if (index == 0) {
                return this.$store.state.gamestate.progressWellBeing;
            } else if (index == 1) {
                return this.$store.state.gamestate.progressEngagement;
            } else if (index == 2) {
                return this.$store.state.gamestate.progressExpression;
            } else if (index == 3) {
                return this.$store.state.gamestate.progressMembership;
            }

            return 0;
        },
        playAudioByRefName(refName) {
            //console.log("Trying to play audio with ref name: " + refName);
            if (refName != null) {
                var refNameString = this.$refs[refName];
                if (refNameString != null) {
                    //console.log("Found this in refs: " + this.$refs[refName][0]);
                    var audioRef = refNameString[0];
                    if (audioRef != null) {
                        audioRef.playAudio();
                    } else {
                        console.log("audio ref is null " + refName);
                    }
                } else {
                    console.log("audio refNameString is null " + refNameString);
                }
            }
        },
        registerAudioIdWithStore(id) {
            console.log("Registering the audio id: " + id + " to be the primary to replay");
            this.$store.commit('setRegisteredAudioId', id);
        },
        enableNewVersion() {
            this.$store.commit('setNewVersion', true);
            this.$store.commit('setSaveGame');
        },
        enableOldVersion() {
            this.$store.commit('setNewVersion', false);
            this.$store.commit('setSaveGame');
        },
        newVersion() {
            // newVersion means Rhiad's new version of the app - lots of changes here, that we're not ready to commit
            // to so we can toggle off and on while in progress

            // TBD - out with the old, we are always now in the new version
            return true;

            //return this.$store.state.gamestate.newVersion;
        },
        pauseAllAudio() {
            var sounds = document.getElementsByTagName('audio');
            for (var i = 0; i < sounds.length; i++) {
                // A bit of a hack here - if the audio id contains sfx (sound effect) never pause it, just let it finish, much simpler this way
                if (!sounds[i].id.includes("sfx")) {
                    if (!sounds[i].id.includes("music")) {
                        sounds[i].pause();
                    } else {
                        // for music, just lower the volume instead of pausing
                        if (this.$store.state.gamestate.muted) {
                            sounds[i].volume = 0;
                        } else {
                            sounds[i].volume = 0.4;
                        }
                    }
                }
            }
        },
        muteAllAudio() {
            this.setAllVolume(0, true, true);
        },
        unmuteAllAudio() {
            this.setAllVolume(1, true, true);
        },
        unmuteAllMusic() {
            var sounds = document.getElementsByTagName('audio');
            for (var i = 0; i < sounds.length; i++) {
                if (sounds[i].id.includes("music")) {
                    console.log("unmuteAllMusic() = " + sounds[i].id);
                    sounds[i].volume = 0.4;
                }
            }
        },
        setAllVolume(vol, affectAudio, affectVideo) {

            if (affectAudio) {
                var sounds = document.getElementsByTagName('audio');
                for (var i = 0; i < sounds.length; i++) {
                    sounds[i].volume = vol;
                }
            }

            if (affectVideo) {
                var soundsVid = document.getElementsByTagName('video');
                for (i = 0; i < soundsVid.length; i++) {
                    soundsVid[i].volume = vol;
                }
            }

        },
        isAnyVideoPlaying() {
            var soundsVid = document.getElementsByTagName('video');
            for (var i = 0; i < soundsVid.length; i++) {
                if (soundsVid[i].paused == false && soundsVid[i].ended == false) {
                    return true;
                }
            }
            return false;
        },
        playRegisteredAudio() {

            this.unmuteAllAudio();

            if (this.isAnyVideoPlaying()) {
                return;
            }

            this.pauseAllAudio();

            var theRegisteredAudioId = this.$store.state.gamestate.registeredAudioId;
            if (theRegisteredAudioId != null &&
                theRegisteredAudioId != "") {
                //console.log("Found element id: " + theRegisteredAudioId);
                var thePlayer = document.getElementById(theRegisteredAudioId);
                if (thePlayer != null) {
                    thePlayer.load();
                    thePlayer.play();
                } else {
                    console.log("Missing audio element: " + theRegisteredAudioId);
                }
            }

        },
        popToTopOfPage() {
            //console.log("Pop to top");
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        },
        isFeatureLocked() {
            // A way to allow users from CFORP to bypass feature locks, so they can continue testing, while client is locked out
            if (this.$store.state.user != null) {
                var email = this.$store.state.user.email;
                if (email.includes("@lecentrefranco")) {
                    return false;
                }
            }
            return true;
        },
        loadFromLocalStorage() {

            // When mounting this page, see if we have a user & gamestate in local storage
            var savedUserString = localStorage.getItem('user');
            var foundLoginInfo = false;

            if (savedUserString != null) {
                //console.log("savedUserString from local storage is:" + savedUserString);
                // Check local storage for a user account, null means a guest
                //console.log("Found user string in local storage, parsing...");
                var savedUser = JSON.parse(savedUserString);
                if (savedUser != null) {
                    console.log("SavedUser email is " + savedUser.email);
                    this.$store.commit('completeLogin', savedUser);
                    foundLoginInfo = true;
                }
            }
            if (!foundLoginInfo) {
                console.log("FAILED TO FIND LOCAL LOGIN INFO!!!!");
            }

            console.log("OK, Logged in = " + this.$store.state.loggedin);

            // Now check for gamestate
            var savedGameStateString = localStorage.getItem('gamestate');
            if (savedGameStateString != null) {
                console.log("Discovered a gamestate from local storage");
            }
            this.loadGameStateString(savedGameStateString);
        },
        loadGameStateString(savedGameStateString) {
            if (savedGameStateString != null) {
                var savedGameState = JSON.parse(savedGameStateString);
                if (savedGameState != null) {
                    console.log("Reading Gamestate: " + savedGameStateString);
                    this.$store.commit('setEmail', savedGameState.email);
                    this.$store.commit('setProgressWellBeing', savedGameState.progressWellBeing);
                    this.$store.commit('setProgressEngagement', savedGameState.progressEngagement);
                    this.$store.commit('setProgressExpression', savedGameState.progressExpression);
                    this.$store.commit('setProgressMembership', savedGameState.progressMembership);
                    this.$store.commit('setArea', savedGameState.area);
                    this.$store.commit('setSituation', savedGameState.situation);
                    this.$store.commit('setCurrentClue', savedGameState.currentClue);
                    // Which situations are completed (0..7)?
                    if (savedGameState.completed != null) {
                        for (var i = 0; i < savedGameState.completed.length; i++) {
                            if (savedGameState.completed[i] == true) {
                                this.$store.commit('setSituationComplete', i);
                            } else {
                                this.$store.commit('setSituationReset', i);
                            }
                        }
                    }
                    // Which clues are found? 0..39  (5 per situation, of 8 situations)
                    if (savedGameState.clues != null) {
                        for (var j = 0; j < savedGameState.clues.length; j++) {
                            //console.log("clue " + j + " ======= " + savedGameState.clues[j]);
                            if (savedGameState.clues[j] == true) {
                                this.$store.commit('setClueFound', j);
                            } else {
                                this.$store.commit('setClueReset', j);
                            }
                        }
                    }
                    this.$store.commit('setCurrentSelection', savedGameState.currentSelection);
                    this.$store.commit('setWatchedVideo', savedGameState.watchedVideo);
                    if (savedGameState.watchedSituationVideo != null) {
                        for (var k = 0; k < savedGameState.watchedSituationVideo.length; k++) {
                            if (savedGameState.watchedSituationVideo[k] == true) {
                                this.$store.commit('setWatchedSituationVideo', k);
                            } else {
                                this.$store.commit('setResetSituationVideo', k);
                            }
                        }
                    }
                    this.$store.commit('setMuted', savedGameState.muted);
                    this.$store.commit('setNewVersion', savedGameState.newVersion);
                    if (savedGameState.blocNote != null) {
                        for (var l = 0; l < savedGameState.blocNote.length; l++) {
                            savedGameState.blocNote[l].currentlyEditing = false;
                            savedGameState.blocNote[l].date = new Date(savedGameState.blocNote[l].date)
                            savedGameState.blocNote[l].situation = parseInt(savedGameState.blocNote[l].situation)
                            savedGameState.blocNote[l].id = parseInt(savedGameState.blocNote[l].id)
                            this.$store.commit('addToBlocNote', savedGameState.blocNote[l]);
                        }
                    }
                }
            } else {
                console.log("Found no gamestate in local storage");
            }
        },
        deleteUserBackend(user) {

            var jsonUser = JSON.stringify(user);

            console.log("deleteUserBackend: json = " + jsonUser);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: jsonUser
            };

            // This posts the game state structure to the UpdateState function of the GameState
            return fetch(`users/deleteaccount`, requestOptions).then(this.handleDeleteResponse);
        },
        handleDeleteResponse(response) {

            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {

                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                console.log("User account delete was successful");
                return data;
            }).catch((err) => {
                console.log("Error was caught" + err);
            });
        },
        // This is the API that saves game state to backend DB
        saveGameState() {

            // Copy our state info into DB structure
            this.$store.commit('updateDbInfo');

            // Start by always saving to local storage
            this.$store.commit('setSaveGame');

            if (this.$store.state.loggedin == false) {
                //console.log("Not logged in, so saving to local storage only.");
                return;
            }

            this.$store.commit('startSavingGameState');

            var stringGameState = JSON.stringify(this.$store.state.dbInfo);
            console.log("Here will be the game state that we save: " + stringGameState);
            console.log("Logged in = " + this.$store.state.loggedin);

            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: stringGameState
            };

            // This posts the game state structure to the UpdateState function of the GameState
            return fetch(`/gamestate/setstate`, requestOptions).then(this.handleResponse);
        },
        handleResponse(response) {

            this.registering = false;

            return response.text().then(text => {
                const data = text && JSON.parse(text);
                if (!response.ok) {

                    const error = (data && data.message) || response.statusText;
                    return Promise.reject(error);
                }
                this.onSaveComplete();
                return data;
            }).catch((err) => {
                console.log("Error was caught" + err);
            });
        },
        onSaveComplete() {
            // Save our game state into local storage for easy access on refresh
            //console.log("Writing our game state to local storage now that Database save is complete: " + this.$store.state.gamestate);

            //localStorage.setItem('gamestate', JSON.stringify(this.$store.state.gamestate));
            this.$store.commit('completeSavingGameState');
            this.saving = false;
        },


        setArea(areaName) {
            let areaIndex = this.getAreaIndexFromAreaName(areaName)
            this.$store.commit('setArea', areaIndex);
        },

        setSituation(situationName) {
            let situationIndex = this.getSituationIndexFromSituationName(situationName)
            this.$store.commit('setSituation', situationIndex);
        },

        getAreaIndexFromAreaName(areaName) {
            let index;
            let elem = this.urlRouteName.find(x => x.areaName == areaName)
            if (elem) {
                index = elem.index;
            }
            return index
        },
        getAreaNameFromAreaIndex(index) {
            let areaName;
            let elem = this.urlRouteName.find(x => x.index == index)
            if (elem) {
                areaName = elem.areaName;
            }
            return areaName
        },


        getSituationIndexFromSituationName(situationName) {
            let index;
            let elem = this.urlSituationsName.find(x => x.situationName == situationName)
            if (elem != undefined) {
                index = elem.index;
            }
            return index
        },
        getSituationNameFromSituationIndex(index) {
            let situationName;
            let elem = this.urlSituationsName.find(x => x.index == index)
            if (elem) {
                situationName = elem.situationName;
            }
            return situationName
        },

        getMatchedIndexArea(situationIndex) {
            situationIndex = parseInt(situationIndex);
            return this.areaSituationsMatch.find(x => x.situations.includes(situationIndex)).index
        },
        getMatchedAreaName(situationIndex) {
            let areaIndex = this.getMatchedIndexArea(situationIndex)
            return this.getAreaNameFromAreaIndex(areaIndex)
        }

    }
}
